export interface NormalizedScore {
  totalScore: number
  count: number
  averageScore?: number
}

export interface ScoredResult {
  score: number
  max_score: number
  section: string
}

export function calculateNormalizedScores(
  results: ScoredResult[]
): Record<string, NormalizedScore> {
  const totals: Record<string, NormalizedScore> = {}
  for (const r of results) {
    const normalized = r.max_score > 0 ? (r.score / r.max_score) * 100 : 0
    if (!totals[r.section]) totals[r.section] = { totalScore: 0, count: 0 }
    totals[r.section].totalScore += normalized
    totals[r.section].count++
  }
  for (const key of Object.keys(totals)) {
    const s = totals[key]
    s.averageScore = Number((s.count > 0 ? s.totalScore / s.count : 0).toFixed(2))
  }
  return totals
}
